export function formatPrice(price: number, fraction = 2,): string {
  return price.toLocaleString("ru-RU", {
    style: "currency",
    maximumFractionDigits: fraction,
    currency: "RUB",
  },);
}
